import {
	DeleteManyFilesRequest,
	GetFileRequest,
	GetFileUrlRequest,
	GetFilesRequest,
	IFtpExportRequest,
	IGetFileExport,
	PatchAssertionSetToFileRequest,
	FilesDirectImportRequest,
	PostFileSettingsRequest,
	PostCheckExportedFilesRequest,
	PostImportSettingsRequest,
	IMergeRequestRequest,
	IFtpMergeRequestRequest,
	PostEdilDeltaExportRequest,
	PostFaterErpExportRequest,
} from 'entities/Files/api/types';
import { axiosInstance } from 'shared/config/axios';
import { getAccessToken } from 'shared/helpers/getAccessToken';

export const getFiles: GetFilesRequest = (data) => {
	return axiosInstance.post(`/files/search`, data);
};

export const getFile: GetFileRequest = (fileId) => {
	return axiosInstance.get(`/files/${fileId}`, {
		headers: {
			Authorization: `Bearer ${getAccessToken()}`,
		},
	});
};

export const getFileUrl: GetFileUrlRequest = (fileId) => {
	return axiosInstance.get(`/files/${fileId}/url`);
};

export const deleteFiles: DeleteManyFilesRequest = (data) => {
	return axiosInstance.delete('/files/delete-many', {
		data: data,
		headers: {
			Authorization: `Bearer ${getAccessToken()}`,
		},
	});
};

export const getFileExport: IGetFileExport = ({ fileId, type }) => {
	return axiosInstance.get(`/files/export/${fileId}?type=${type}`, {
		headers: {
			Authorization: `Bearer ${getAccessToken()}`,
		},
		responseType: 'blob',
	});
};

export const exportFileFtp: IFtpExportRequest = (data) => {
	return axiosInstance.post(`/files/export/ftp-export`, data);
};

export const mergeFilesFtp: IFtpMergeRequestRequest = (data) => {
	return axiosInstance.post(`/files/export/ftp-merge-multiple`, data);
};

export const mergeFiles: IMergeRequestRequest = (data) => {
	return axiosInstance.post(`/files/export/merge-multiple`, data, { responseType: 'blob' });
};

export const getMergeExportDownloadUrl = (fileExportJobId: string) => {
	return axiosInstance.get<{ url: string }>(`/files/export/merge-multiple/${fileExportJobId}/download`);
};

export const patchAssertionSetToFile: PatchAssertionSetToFileRequest = (data) => {
	return axiosInstance.patch('/files/assertion-sets', data);
};

export const postFileSettings: PostFileSettingsRequest = (data) => {
	return axiosInstance.put('/files/default-export', data);
};

export const postDefaultImport: PostImportSettingsRequest = (data) => {
	return axiosInstance.put('/files/default-import', data);
};

export const startFilesDirectImport: FilesDirectImportRequest = (data) => {
	return axiosInstance.post('/files/direct-import', data, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const checkExportedFiles: PostCheckExportedFilesRequest = (data) => {
	return axiosInstance.post(`/files/export/check`, data);
};

export const postExportEdildeltaErp: PostEdilDeltaExportRequest = (data) => {
	return axiosInstance.post(`/files/export/edildelta-erp`, data);
};

export const postExportFaterErp: PostFaterErpExportRequest = (data) => {
	return axiosInstance.post(`/files/export/fater-erp`, data);
};
